<template>
  <div class="login-main">
    <div class="bg"></div>
    <div class="login-box">
      <BoxCorner />
      <div class="title">欢迎登录</div>
      <div class="title-1">{{ companyInfo.title }}</div>

      <div class="login-input" style="margin-top: 30px">
        <el-input
          v-model="username"
          placeholder="请输入手机"
          prefix-icon="el-icon-user"
          @keyup.enter.native="submit"
        ></el-input>
      </div>

      <div class="login-input">
        <el-input
          v-model="password"
          placeholder="请输入密码"
          prefix-icon="el-icon-lock"
          show-password
          @keyup.enter.native="submit"
        ></el-input>
      </div>

      <div class="code-input">
        <el-input
          v-model="code"
          placeholder="请输入验证码"
          @keyup.enter.native="submit"
        ></el-input>
        <div class="code-box" v-loading="captchaLoading" v-if="captchaData.img">
          <img :src="captchaData.img" alt="" @click="getCaptcha" />
        </div>
      </div>

      <div class="func-btn">
        <div class="left">
          <el-checkbox v-model="rememberUser">记住密码</el-checkbox>
        </div>
        <div class="right" v-if="$SHOW_SMS">
          <div
            class="btn"
            @click="
              passwordType = 1;
              passwordDialogShow = true;
            "
          >
            忘记密码
          </div>
          <div
            class="btn"
            @click="
              passwordType = 2;
              passwordDialogShow = true;
            "
          >
            用户注册
          </div>
        </div>
      </div>

      <div class="login-btn">
        <el-button type="primary" @click="submit" :loading="loading"
          >登入</el-button
        >
      </div>

      <div class="login-bottom">
        <div class="bottom-tip">为了更好的用户体验效果</div>
        <div class="bottom-tip-1">
          推荐使用<span>谷歌浏览器</span>或<span>Edge浏览器</span>,屏幕分辨率使用1920*1080
        </div>
      </div>

      <div class="dialog-main">
        <el-dialog
          :visible.sync="passwordDialogShow"
          :title="passwordType == 2 ? '用户注册' : '忘记密码'"
          width="400px"
          @closed="clearPasswordData"
        >
          <div class="dialog-content">
            <div class="item" v-if="passwordType == 2">
              <div class="item-left">用户名</div>
              <div class="item-input">
                <el-input
                  v-model="passwordParams.user"
                  placeholder="请输入用户名"
                  size="small"
                ></el-input>
              </div>
            </div>
            <div class="item">
              <div class="item-left">手机号码</div>
              <div class="item-input">
                <el-input
                  v-model="passwordParams.mobile"
                  placeholder="请输入手机号码"
                  size="small"
                ></el-input>
              </div>
            </div>
            <div class="item">
              <div class="item-left">手机验证码</div>
              <div class="item-input">
                <el-input
                  v-model="passwordParams.authcode"
                  placeholder="请输入验证码"
                  size="small"
                ></el-input>
              </div>
              <div class="code-item">
                <el-button type="primary" size="small" @click="getCode">{{
                  codeText
                }}</el-button>
              </div>
            </div>
            <div class="item">
              <div class="item-left">密码</div>
              <div class="item-input">
                <el-input
                  v-model="passwordParams.password"
                  show-password
                  placeholder="请输入密码"
                  size="small"
                ></el-input>
              </div>
            </div>
            <div class="item">
              <div class="item-left">确认密码</div>
              <div class="item-input">
                <el-input
                  v-model="passwordParams.confirmPassword"
                  show-password
                  placeholder="请输入确认密码"
                  size="small"
                ></el-input>
              </div>
            </div>

            <div class="dialog-footer">
              <el-button @click="passwordDialogShow = false" size="small"
                >取消</el-button
              >
              <el-button
                type="primary"
                size="small"
                @click="passwordSubmit"
                :loading="passwordLoading"
                >确认</el-button
              >
            </div>
          </div>
        </el-dialog>
      </div>
    </div>

    <div class="login-copyright" v-if="companyInfo">
      <div>{{ companyInfo.companyname }}</div>
      {{ companyInfo.version }}
      <span style="margin-left: 5px">
        版权所有 ©{{ companyInfo.copyright }}</span
      >
    </div>
  </div>
</template>

<script>
import BoxCorner from "@/components/boxCorner";

import { config } from "@/api/function.js";
import { EncryStrHex } from "@/plugins/Des.js";

import { mapState } from "vuex";

export default {
  components: {
    BoxCorner,
  },
  created() {},
  data() {
    return {
      username: "",
      password: "",
      code: "",
      passwordType: 0,
      loading: false,
      passwordLoading: false,
      passwordDialogShow: false,
      captchaLoading: false,
      captchaData: {},
      rememberUser: false,
      passwordParams: {},
      codeText: "获取验证码",
      setInt: null,
      passwordSessionid: null,
    };
  },
  watch: {},
  computed: {
    ...mapState({
      companyInfo: (state) => state.user.companyInfo || {},
    }),
  },
  mounted() {
    if (localStorage.getItem("rememberUser")) {
      this.rememberUser = true;
      let user = JSON.parse(localStorage.getItem("userAccount"));
      if (user) {
        this.username = user.account;
        this.password = user.password;
      }
    }
    this.getCaptcha();
  },
  methods: {
    clearPasswordData() {
      clearInterval(this.setInt);
      this.passwordParams = {};
      this.passwordSessionid = null;
      this.codeText = "获取验证码";
    },
    getCode() {
      let time = 60;
      if (this.codeText == "获取验证码") {
        if (!this.passwordParams.mobile || !this.passwordParams.mobile.length) {
          this.$message.warning("请输入手机号");
          return;
        }
        if (!this.checkPhone(this.passwordParams.mobile)) {
          this.$message.warning("请输入正确手机号");
          return;
        }
        config()
          .getPhoneverification({ mobile: this.passwordParams.mobile })
          .then((res) => {
            this.$message.success("验证码已发送至您的手机，请注意查收");
            this.codeText = "60s";
            this.passwordSessionid = res.data.sessionid;
            this.setInt = window.setInterval(() => {
              --time;
              this.codeText = time + "s";
              if (time == 0) {
                this.codeText = "获取验证码";
                clearInterval(this.setInt);
              }
            }, 1000);
          });
      }
    },
    getCaptcha() {
      if (this.captchaLoading) {
        return;
      }
      this.captchaLoading = true;
      config()
        .getCaptcha()
        .then((res) => {
          this.captchaData = res.data;
        })
        .finally(() => {
          this.captchaLoading = false;
        });
    },
    submit() {
      if (!this.username.length) {
        this.$message.warning("请输入手机号码");
        return;
      }
      if (!this.password.length) {
        this.$message.warning("请输入密码");
        return;
      }
      if (!this.code.length) {
        this.$message.warning("请输入验证码");
        return;
      }
      this.loading = true;

      let obj = {
        account: this.username,
        password: EncryStrHex(EncryStrHex(this.password, "user"), "lcrj"),
        authcode: this.code,
        sessionid: this.captchaData.sessionid,
      };
      config()
        .login(obj)
        .then((res) => {
          localStorage.setItem("rememberUser", this.rememberUser);

          if (this.rememberUser) {
            let user = {
              account: this.username,
              password: this.password,
            };
            localStorage.setItem("userAccount", JSON.stringify(user));
          }

          this.$message.success("登录成功");
          this.$store.commit("user/setUserInfo", res.data);
          this.$router.push("/index");
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
            this.getCaptcha();
          }, 1000);
        });
    },
    passwordSubmit() {
      if (!this.passwordParams.mobile || !this.passwordParams.mobile.length) {
        this.$message.warning("请输入手机号码");
        return;
      }
      if (!this.checkPhone(this.passwordParams.mobile)) {
        this.$message.warning("请输入正确手机号码");
        return;
      }
      if (
        !this.passwordParams.authcode ||
        !this.passwordParams.authcode.length
      ) {
        this.$message.warning("请输入验证码");
        return;
      }
      if (
        !this.passwordParams.password ||
        !this.passwordParams.password.length
      ) {
        this.$message.warning("请输入密码");
        return;
      }
      if (
        !this.passwordParams.confirmPassword ||
        !this.passwordParams.confirmPassword.length
      ) {
        this.$message.warning("请输入确认密码");
        return;
      }
      if (
        this.passwordParams.confirmPassword !== this.passwordParams.password
      ) {
        this.$message.warning("密码与确认密码不一致");
        return;
      }
      this.passwordLoading = true;
      if (this.passwordType == 2) {
        let obj = {
          sessionid: this.passwordSessionid,
          password: EncryStrHex(
            EncryStrHex(this.passwordParams.password, "user"),
            "lcrj"
          ),
          user: this.passwordParams.user,
          mobiles: this.passwordParams.mobile,
          authcode: this.passwordParams.authcode,
          name: this.passwordParams.user,
          identificationcard: "",
          phones: "",
          sex: "",
          email: "",
          qq: "",
          weixin: "",
          dingding: "",
          photo: "",
          remark: "",
          mobile: this.passwordParams.mobile,
        };
        config()
          .addinfo(obj)
          .then(() => {
            this.$message.success("注册成功");
            this.passwordDialogShow = false;
          })
          .finally(() => {
            this.passwordLoading = false;
          });
      } else {
        let obj = {
          mobile: this.passwordParams.mobile,
          password: EncryStrHex(
            EncryStrHex(this.passwordParams.password, "user"),
            "lcrj"
          ),
          authcode: this.passwordParams.authcode,
          sessionid: this.passwordSessionid,
        };
        config()
          .changepwdex(obj)
          .then(() => {
            this.$message.success("重置密码成功");
            this.passwordDialogShow = false;
          })
          .finally(() => {
            this.passwordLoading = false;
          });
      }
    },
    checkPhone(TEL) {
      let strTemp = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
      if (strTemp.test(TEL)) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.login-main {
  width: 100vw;
  height: 100vh;
  background: #000a22;
  overflow: hidden;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-image: url("../../assets/images/login-bg-1.png");
  background-size: 800px;
  background-position: 25% center;
  background-repeat: no-repeat;
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.05;
    background: url("../../assets/images/login-bg-2.png") no-repeat 85% -70%,
      url("../../assets/images/login-bg-3.png") 10% 10% no-repeat;
  }
  .login-box {
    position: relative;
    width: 443px;
    // height: 470px;
    border: 1px solid #022d7d;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
    background: rgba(2, 8, 25, 0.49);
    margin: 0 5%;
    padding: 0 20px;
    .title {
      font-size: 28px;
      font-weight: 700;
      color: #bfd4f8;
      line-height: 32px;
      padding-top: 30px;
    }
    .title-1 {
      font-size: 22px;
      font-weight: 400;
      color: #bfd4f8;
      line-height: 28px;
      padding-top: 14px;
    }
    .login-input {
      margin-top: 15px;
    }
    .code-input {
      margin-top: 15px;
      display: flex;
      .code-box {
        width: 145px;
        height: 40px;
        margin-left: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #216ea6;
        height: 40px;
        background-color: #1a4d80;
        border-radius: 5px;
        overflow: hidden;
        flex-shrink: 0;
        img {
          max-width: 100%;
          max-height: 100%;
          cursor: pointer;
        }

        ::v-deep .el-loading-spinner {
          margin-top: -16px;
          height: 100%;
          .circular {
            width: 30px;
            height: 30px;
          }
        }
      }
    }
    .login-btn {
      width: 100%;
      .el-button {
        margin-top: 5px;
        width: 100%;
      }
    }

    .func-btn {
      display: flex;
      justify-content: space-between;
      margin: 20px 0;
      font-size: 14px;
      color: #bfd4f8;
      .left {
        ::v-deep .el-checkbox__label {
          color: #bfd4f8;
        }
      }
      .right {
        display: flex;
      }
      .btn {
        margin-left: 30px;
        cursor: pointer;
      }
    }

    .login-bottom {
      width: 100%;
      margin-top: 30px;
      .bottom-tip {
        text-align: center;
        font-size: 14px;
        color: #cee1f5;
        line-height: 30px;
        width: 100%;
      }
      .bottom-tip-1 {
        text-align: center;
        font-size: 12px;
        line-height: 20px;
        color: #a1c7ed;
        margin-bottom: 20px;
        span {
          color: #33a0ff;
        }
      }
    }
  }

  .dialog-main {
    .dialog-content {
      padding: 10px;
      .item {
        display: flex;
        align-items: center;
        margin-top: 10px;
        .item-left {
          flex-shrink: 0;
          font-size: 13px;
          color: #fff;
          width: 100px;
          text-align: right;
          padding-right: 20px;
        }
        .item-input {
          width: 100%;
        }
        .code-item {
          margin-left: 10px;
          flex-shrink: 0;
        }
      }
      .dialog-footer {
        width: 100%;
        border-top: 1px solid #216ea6;
        margin-top: 20px;
        padding-top: 10px;
        // height: 50;
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  .login-copyright {
    position: absolute;
    bottom: 0;
    left: 0;
    line-height: 25px;
    bottom: 15px;
    width: 100%;
    text-align: center;
    color: #cee1f5;
    font-family: Arial;
    font-size: 11px;
    letter-spacing: 1px;
  }
}
</style>
